module.exports = __webpack_public_path__ + "img/frame_124.c7cf140d.svg";